import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {Form, Spinner} from 'react-bootstrap'
import {useEffect} from 'react'
import {parseId} from '../../../helpers'
import {useMutation} from '@apollo/client'
import {toast} from 'react-toastify'
import {IModalAddPolicyProps, IResCreatePolicyType} from '../policyTypeTypes'
import {ADD_EDIT_POLICY_TYPE} from '../../../gql/mutations/policyTypeMutation'

const validationSchema = Yup.object({
  typePolicy: Yup.string().required(),
  idCat: Yup.string().required(),
  id: Yup.string(),
})

export const ModalAddEditPolicyType: React.FC<IModalAddPolicyProps> = ({
  isOpen,
  onClose,
  refetch,
  info,
}) => {
  const [gqlCreate, {data, loading, error}] =
    useMutation<IResCreatePolicyType>(ADD_EDIT_POLICY_TYPE)
  const formik = useFormik({
    initialValues: {
      typePolicy: '',
      idCat: '',
      id: '',
    },
    validationSchema,
    onSubmit: (values) => {
      if (!values.idCat) return
      const input: {typePolicy: string; category: string; id?: string} = {
        typePolicy: values.typePolicy,
        category: values.idCat,
      }
      if (values.id) {
        input.id = values.id
      }
      gqlCreate({
        variables: {
          input,
        },
      })
    },
  })

  useEffect(() => {
    if (!info.idCat) return
    formik.setFieldValue('idCat', parseId(info.idCat))
    if (info.id && info.typePolicy) {
      formik.setFieldValue('typePolicy', info.typePolicy)
      formik.setFieldValue('id', parseId(info.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info])

  useEffect(() => {
    if (error) toast.error(`Error: ${error.message}`)
  }, [error])

  useEffect(() => {
    if (!data) return
    if (data.policyTypeCreateupdateMutation?.policyType?.id) {
      toast.success(`Policy Type ${info.id ? 'edited' : 'added'} correctly`)
      onClose()
      refetch()
    } else if (data.policyTypeCreateupdateMutation.errors?.length > 0) {
      toast.error(
        `Error: ${
          data.policyTypeCreateupdateMutation.errors?.[0]?.messages?.[0] || 'something happened'
        }`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{info.id ? 'Edit Policy Type' : 'Add Policy Type'}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <div>
            <Form.Label htmlFor='typePolicy'>Policy Type</Form.Label>
            <Form.Control
              id='typePolicy'
              aria-describedby='typePolicy'
              value={formik.values.typePolicy}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              isInvalid={Boolean(formik.errors.typePolicy && formik.touched.typePolicy)}
            />
            {formik.errors.typePolicy && formik.touched.typePolicy && (
              <Form.Text id='error-typePolicy' className='text-danger'>
                {formik.errors.typePolicy}
              </Form.Text>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button type='button' variant='secondary' onClick={onClose}>
            Cancel
          </Button>
          <Button type='submit' variant='primary' disabled={loading}>
            {loading && <Spinner size='sm' animation='border' className='me-2' />}
            Save Changes
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}
